import { createSlice } from "@reduxjs/toolkit";
import { fetchMarketingDetail, getMarketingInvitationThunk, getProductGetThunk, getRegisteredCampaignThunk } from "./thunk";

export const initialState: any = {
    campaignInvitation: [],
    marketingData: {},
    campaignRegistered: [],
    products: [],
    count :{}
};

const CampaignSlice = createSlice({
    name: 'CampaignSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getMarketingInvitationThunk.fulfilled, (state: any, action: any) => {
            state.campaignInvitation = action.payload;
        });

        builder.addCase(getMarketingInvitationThunk.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        })
        builder.addCase(getProductGetThunk.fulfilled, (state: any, action: any) => {
            state.products = action.payload.data;
            state.count = action.payload.counts;
        });

        builder.addCase(getProductGetThunk.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        })
        builder.addCase(getRegisteredCampaignThunk.fulfilled, (state: any, action: any) => {
            state.campaignRegistered = action.payload.data;
        });

        builder.addCase(getRegisteredCampaignThunk.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        })
        .addCase(fetchMarketingDetail.pending, (state:any) => {
            state.loading = true;  // ✅ Jab API call ho rahi ho
        })
        .addCase(fetchMarketingDetail.fulfilled, (state: any, action: any) => {
            state.loading = false;
         
            state.marketingData = action.payload || null;
            state.counts = action.payload?.counts || 0;
            state.error = null;
        })
        .addCase(fetchMarketingDetail.rejected, (state: any, action: any) => {
            state.loading = false;
            state.error = action.payload || "Something went wrong";
        })

},

    }
);

export default CampaignSlice.reducer;